import {
  Button,
  Divider,
  Form,
  Input,
  Select,
  Switch,
  Modal,
  List,
  Card,
  Badge,
  Alert,
  Space,
  Tag,
  Typography,
  message,
} from "antd";
import { ScanOutlined, WarningOutlined, CopyOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import commonApi from "utils/api";
import { useDispatch, useSelector } from "react-redux";
import { fetchSuperConfig, updateSuperConfig } from "./slice";
import api from "./api";

const { Text } = Typography;

export default function System() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { superConfig, isLoading } = useSelector((state) => state.superConfig);
  const [banks, setBanks] = useState([]);

  // Scan violating restaurants states
  const [isViolatingModalVisible, setIsViolatingModalVisible] = useState(false);
  const [violatingData, setViolatingData] = useState(null);
  const [isLoadingViolating, setIsLoadingViolating] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("all");

  useEffect(() => {
    dispatch(fetchSuperConfig());
  }, [dispatch]);

  useEffect(() => {
    const getBanks = async () => {
      const data = await commonApi.getBanks();
      if (!data || data.error) {
        toast.error(data.error.msg);
      } else {
        setBanks(data);
      }
    };
    getBanks();
  }, []);

  useEffect(() => {
    const banking = {
      bankId: superConfig.banking?.bankId || "",
      bankName: superConfig.banking?.bankName || "",
      accountNumber: superConfig.banking?.accountNumber || "",
      accountName: superConfig.banking?.accountName || "",
    };
    const wallet = {
      enable: superConfig.wallet?.enable || false,
      withdrawEnable: superConfig.wallet?.withdrawEnable || false,
      rechargeEnable: superConfig.wallet?.rechargeEnable || false,
      paymentEnable: superConfig.wallet?.paymentEnable || false,
      qrPaymentEnable: superConfig.wallet?.qrPaymentEnable || false,
    };
    const blackKeywords = superConfig.blackKeywords || [];
    form.setFieldsValue({
      banking,
      wallet,
      blackKeywords: blackKeywords.join(","),
    });
  }, [superConfig, form]);

  const onFinish = (config) => {
    console.log(config);
    config.blackKeywords = config.blackKeywords.split(",");
    dispatch(updateSuperConfig(config));
  };

  const handleScanViolatingRestaurants = async () => {
    try {
      setIsLoadingViolating(true);
      const response = await api.scanViolatingRestaurants();

      if (response.success) {
        setViolatingData(response);
        setIsViolatingModalVisible(true);
      } else {
        toast.error("Lỗi khi quét quán vi phạm");
      }
    } catch (error) {
      console.error("Error scanning violating restaurants:", error);
      toast.error("Lỗi khi quét quán vi phạm");
    } finally {
      setIsLoadingViolating(false);
    }
  };

  const handleCopyRestaurantId = async (restaurantId) => {
    try {
      await navigator.clipboard.writeText(restaurantId);
      message.success("Đã copy ID quán thành công!");
    } catch (error) {
      console.error("Error copying restaurant ID:", error);
      message.error("Lỗi khi copy ID quán");
    }
  };

  const getUniqueRegions = (data) => {
    if (!data || !data.data) return [];
    const regions = data.data
      .map((item) => item.restaurant.region?.name)
      .filter(Boolean);
    return [...new Set(regions)];
  };

  const getFilteredData = (data, regionFilter) => {
    if (!data || !data.data) return [];
    if (regionFilter === "all") return data.data;
    return data.data.filter(
      (item) => item.restaurant.region?.name === regionFilter
    );
  };

  const highlightViolatedKeywords = (text, violatedKeywords) => {
    if (!text || !violatedKeywords || violatedKeywords.length === 0) {
      return text;
    }

    let highlightedText = text;
    violatedKeywords.forEach((keyword) => {
      const regex = new RegExp(`(${keyword})`, "gi");
      highlightedText = highlightedText.replace(
        regex,
        `<span style="color: #ff4d4f; font-weight: 600; background-color: #fff2f0; padding: 2px 4px; border-radius: 3px;">$1</span>`
      );
    });

    return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
  };

  return (
    <>
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        onFinish={onFinish}
      >
        <Divider orientation="left">Tài khoản ngân hàng GOKA</Divider>
        <Form.Item
          label="Ngân hàng"
          name={["banking", "bankId"]}
          rules={[{ required: true, message: "Trường này là bắt buộc" }]}
        >
          <Select
            showSearch
            placeholder="Chọn ngân hàng"
            optionFilterProp="label"
            options={banks.map((bank) => ({
              value: bank.id,
              label: bank.name,
            }))}
          ></Select>
        </Form.Item>
        <Form.Item
          label="Số tài khoản"
          name={["banking", "accountNumber"]}
          rules={[{ required: true, message: "Trường này là bắt buộc" }]}
        >
          <Input placeholder="Nhập số tài khoản" />
        </Form.Item>
        <Form.Item
          label="Chủ tài khoản"
          name={["banking", "accountName"]}
          rules={[{ required: true, message: "Trường này là bắt buộc" }]}
        >
          <Input placeholder="Nhập chủ tài khoản" />
        </Form.Item>
        <br />
        <Divider orientation="left">Ví GOKA</Divider>
        <br />
        <Form.Item label="Kích hoạt" name={["wallet", "enable"]}>
          <Switch />
        </Form.Item>
        <Form.Item
          label="Cho phép rút tiền"
          name={["wallet", "withdrawEnable"]}
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Cho phép nạp tiền"
          name={["wallet", "rechargeEnable"]}
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Cho phép thanh toán"
          name={["wallet", "paymentEnable"]}
        >
          <Switch />
        </Form.Item>
        <Form.Item
          label="Cho phép thanh toán VietQR"
          name={["wallet", "qrPaymentEnable"]}
        >
          <Switch />
        </Form.Item>
        <br />
        <Divider orientation="left">Từ khóa bị cấm</Divider>
        <br />
        <Form.Item label="Từ khóa bị cấm" name={["blackKeywords"]}>
          <Input.TextArea
            placeholder="Điền các keyword cách nhau bởi dấu ,"
            autoSize={{
              minRows: 4,
              maxRows: 10,
            }}
          />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            type="primary"
            danger
            icon={<ScanOutlined />}
            onClick={handleScanViolatingRestaurants}
            loading={isLoadingViolating}
            style={{
              marginBottom: "16px",
            }}
          >
            <WarningOutlined style={{ marginRight: "8px" }} />
            Quét quán vi phạm
          </Button>
        </Form.Item>
        <br />
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Cập nhật
          </Button>
        </Form.Item>
      </Form>

      {/* Violating Restaurants Modal */}
      <Modal
        title={
          <div>
            <WarningOutlined style={{ color: "#ff4d4f", marginRight: "8px" }} />
            Danh sách quán vi phạm
          </div>
        }
        open={isViolatingModalVisible}
        onCancel={() => {
          setIsViolatingModalVisible(false);
          setSelectedRegion("all");
        }}
        footer={[
          <Button
            key="close"
            onClick={() => {
              setIsViolatingModalVisible(false);
              setSelectedRegion("all");
            }}
          >
            Đóng
          </Button>,
        ]}
        width={1000}
        style={{ top: 20 }}
      >
        {violatingData && (
          <div>
            <Alert
              message={`Tìm thấy ${violatingData.total} quán vi phạm với tổng cộng ${violatingData.totalDishes} món ăn vi phạm`}
              type="warning"
              showIcon
              style={{ marginBottom: "20px" }}
            />

            {violatingData.blackKeywords && (
              <div style={{ marginBottom: "20px" }}>
                <Text strong style={{ color: "#ff4d4f" }}>
                  Từ khóa bị cấm:
                </Text>
                <div style={{ marginTop: "8px" }}>
                  <Space size={[8, 8]} wrap>
                    {violatingData.blackKeywords.map((keyword, index) => (
                      <Tag
                        key={index}
                        color="red"
                        style={{ borderRadius: "4px" }}
                      >
                        {keyword}
                      </Tag>
                    ))}
                  </Space>
                </div>
              </div>
            )}

            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Text strong>Lọc theo khu vực:</Text>
              <Select
                value={selectedRegion}
                onChange={setSelectedRegion}
                style={{ width: 200 }}
                placeholder="Chọn khu vực"
              >
                <Select.Option value="all">Tất cả khu vực</Select.Option>
                {getUniqueRegions(violatingData).map((region, index) => (
                  <Select.Option key={index} value={region}>
                    {region}
                  </Select.Option>
                ))}
              </Select>
              <Text type="secondary">
                (Hiển thị{" "}
                {getFilteredData(violatingData, selectedRegion).length} quán)
              </Text>
            </div>

            <List
              itemLayout="vertical"
              dataSource={getFilteredData(violatingData, selectedRegion)}
              renderItem={(item) => (
                <List.Item>
                  <Card
                    title={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CopyOutlined
                          style={{
                            marginRight: "8px",
                            color: "#1890ff",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                          onClick={() =>
                            handleCopyRestaurantId(item.restaurant._id)
                          }
                          title="Copy ID quán"
                        />
                        <Text strong style={{ fontSize: "16px" }}>
                          {item.restaurant.name}
                        </Text>
                      </div>
                    }
                    extra={
                      <Badge
                        count={item.violatingDishes.length}
                        text="món vi phạm"
                        style={{ backgroundColor: "#ff4d4f" }}
                      />
                    }
                    style={{
                      border: "1px solid #ff7875",
                      borderRadius: "8px",
                    }}
                  >
                    <div>
                      <Text
                        strong
                        style={{
                          color: "#ff4d4f",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Các món ăn vi phạm:
                      </Text>
                      <List
                        size="small"
                        dataSource={item.violatingDishes}
                        renderItem={(dish) => (
                          <List.Item>
                            <div style={{ width: "100%" }}>
                              <div style={{ marginBottom: "4px" }}>
                                <Text strong style={{ fontSize: "14px" }}>
                                  {highlightViolatedKeywords(
                                    dish.name,
                                    dish.violatedKeywords
                                  )}
                                </Text>
                              </div>
                              {dish.description && (
                                <div style={{ marginBottom: "8px" }}>
                                  <Text
                                    type="secondary"
                                    style={{ fontSize: "13px" }}
                                  >
                                    {highlightViolatedKeywords(
                                      dish.description,
                                      dish.violatedKeywords
                                    )}
                                  </Text>
                                </div>
                              )}
                            </div>
                          </List.Item>
                        )}
                      />
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          </div>
        )}
      </Modal>
    </>
  );
}
